import type { IVisitShopItem } from '../redux/shop'

export interface IMergedVisitShopItem {
  productId: string
  name: string
  imageUrl?: string
  quantity: number
  /** True when every underlying order line for this product is delivered. */
  delivered: boolean
  orderItemIds: string[]
}

/** Combine duplicate products across orders into one row (e.g. Turmeric ×2). */
export function mergeVisitShopItemsByProduct(items: IVisitShopItem[]): IMergedVisitShopItem[] {
  const byProduct = new Map<string, IMergedVisitShopItem>()

  for (const item of items) {
    const existing = byProduct.get(item.productId)
    if (existing) {
      existing.quantity += item.quantity
      existing.orderItemIds.push(item.orderItemId)
      existing.delivered = existing.delivered && item.delivered
    } else {
      byProduct.set(item.productId, {
        productId: item.productId,
        name: item.name,
        imageUrl: item.imageUrl,
        quantity: item.quantity,
        delivered: item.delivered,
        orderItemIds: [item.orderItemId],
      })
    }
  }

  return Array.from(byProduct.values())
}
